/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VmcLinkedAccountState = 'ACTIVE' | 'BROKEN' | 'DELETED';

export const VmcLinkedAccountState = {

    ACTIVE: 'ACTIVE' as VmcLinkedAccountState,

    BROKEN: 'BROKEN' as VmcLinkedAccountState,

    DELETED: 'DELETED' as VmcLinkedAccountState
};

